<div class="order-form">
  <div class="order-panel-title m-b-16" *ngIf="!isViewSchedule">
    {{'vbeiOrderDetails' | translate}}
  </div>
  <p-panel class="order-panel p-panel-no-header">
    <div class="flex-body flex-column w-full remove-flex-print">
      <div class="form-horizontal">
        <div class="form-group" *ngIf="orderDetails.OrderName && !isViewSchedule; else scheduleName">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiOrderTitle' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.OrderName}}</div>
        </div>
        <div class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiEurofinsOrderReference' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.OrderReference}}</div>
        </div>
        <div class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiAccount' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.account.code + ' - ' + orderDetails.account.name}}</div>
        </div>
        <div class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiAccountAddress' | translate}}</span>
          </div>
          <div class="form-input-div" [innerHTML]="accountFormattedAddress"></div>

        </div>
        <div class="form-group" *ngIf="!isViewSchedule; else scheduleCreatedOn">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiCreatedOn' | translate}}</span>
          </div>
          <div class="form-input-div">{{ orderDetails.CreatedOn | date :'MM/dd/yyyy hh:mm:ss +5:30'}}</div>
        </div>
        <div class="form-group" *ngIf="!isViewSchedule; else scheduleCreatedBy">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiCreatedBy' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.CreatedByName}}</div>
        </div>
        <div class="form-group" *ngIf="!isViewSchedule">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiStatus' | translate}}</span>
          </div>
          <div class="form-input-div red" *ngIf="orderDetails.Status === 'Pending'">{{orderDetails.displayStatus}}</div>
          <div class="form-input-div green" *ngIf="orderDetails.Status !== 'Pending'"><b>{{orderDetails.Status}}</b>
          </div>
        </div>
        <div *ngIf="orderDetails.displayPrice" class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiAnalysisCost' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.AnalysisCost}}</div>
        </div>
        <div *ngIf="orderDetails.displayShippingPrice && !orderDetails.selfShipping" class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiShippingCost' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.ShippingCost}}</div>
        </div>
        <div *ngIf="orderDetails.displayPrice || orderDetails.displayShippingPrice" class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiOrderTotal' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.OrderTotal}}</div>
        </div>
        <div class="form-group" *ngIf="orderDetails.CustomerReference">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiPO' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.CustomerReference}}</div>
        </div>
        <div class="form-group" *ngIf="orderDetails.CustomerComment">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiOrderNotes' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.CustomerComment}}</div>
        </div>
        <div class="form-group" *ngIf="hasAttachments()" [ngClass] = "{'dont-print' : noClean()}">
          <div class="form-label-div">
            <span class="form-label form-label-top">
              <span>{{'vbeiOrderAttachment' | translate}}</span>
            </span>
          </div>
          <div class="form-input-div">
            <div class="files-container">
              <div class="file-container" *ngFor="let file of attachments">
                <div class="file-content uploaded">
                  <span class="file-icon m-r-8 m-b-auto">
                    <img [src]="file.icon" width="20" height="24" [ngClass] = "{'dont-print' : !clean(file)}"/>
                  </span>
                  <a class="anchor file-name m-r-36 dont-print" (click)="downloadAttachment(file)">{{file.name}}</a>
                  <a class="anchor file-name m-r-36 anchor-print print-me" *ngIf="clean(file)"
                    [href]="downloadUrl + file.internalFileName">{{file.name}}</a>
                </div>
                <span class="copy-link print-me" *ngIf="clean(file)" [ngClass]="{'hide-in-chrome' : isChrome}">
                  {{downloadUrl + file.internalFileName}}</span>
              </div>
            </div>
            <div class="older-doc-info" *ngIf="getArchivedFilesCount()">
              {{getArchivedFilesMessage()}}
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="orderDetails.labDetails">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiReceivingLab' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.labDetails.code + ' - ' + orderDetails.labDetails.name}}</div>
        </div>
        <div class="form-group" *ngIf="orderDetails.labDetails">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiReceivingLabAddress' | translate}}</span>
          </div>
          <div class="form-input-div" [innerHTML]="labFormattedAddress"></div>
        </div>
        <div class="form-group page-break">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiOrderTemplate' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.orderTemplate?.code + ' - ' + orderDetails.orderTemplate?.name}}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiContract' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.contract?.code + ' - ' + orderDetails.contract?.name}}
          </div>
        </div>
        <div class="form-group"
          [ngClass]="{'form-group-last': !(orderDetails.additionalFields && orderDetails.additionalFields.length > 0)}">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiQuotation' | translate}}</span>
          </div>
          <div class="form-input-div">{{orderDetails.quotation?.code + ' - ' + orderDetails.quotation?.name}}</div>
        </div>

        <div class="form-group dont-print exclude-print" *ngIf="!isViewSchedule">
          <div class="form-label-div">
            <span class="form-label">{{'vbeiOrderBarcode' | translate}}</span>
          </div>
          <div class="form-input-div">
            <ngx-barcode class="order-barcode" [bc-element-type]="'img'" [bc-font-size]="'25'"
              [bc-value]="orderDetails.OrderReference" [bc-display-value]="true"></ngx-barcode>
          </div>
        </div>
        <app-additional-fields *ngIf="orderDetails.additionalFields && orderDetails.additionalFields.length > 0"
          [additionalFields]="orderDetails.additionalFields">
        </app-additional-fields>
      </div>
    </div>
  </p-panel>
</div>
<ng-template #scheduleName>
  <div class="form-group" *ngIf="scheduleOrderDetails?.scheduleName && isViewSchedule">
    <div class="form-label-div">
      <span class="form-label">{{'vbeiScheduleOrderName' | translate}}</span>
    </div>
    <div class="form-input-div">{{scheduleOrderDetails.scheduleName}}</div>
  </div>
</ng-template>
<ng-template #scheduleCreatedOn>
  <div class="form-group">
    <div class="form-label-div">
      <span class="form-label">{{'vbeiCreatedOn' | translate}}</span>
    </div>
    <div class="form-input-div">{{ scheduleOrderDetails.createdOn | date :'MM/dd/yyyy HH:MM:SS +5:30'}}</div>
  </div>
</ng-template>
<ng-template #scheduleCreatedBy>
  <div class="form-group">
    <div class="form-label-div">
      <span class="form-label">{{'vbeiCreatedBy' | translate}}</span>
    </div>
    <div class="form-input-div">{{scheduleOrderDetails.createdByName}}</div>
  </div>
</ng-template>